import { useAtomValue } from "jotai";
import { customerDetailsAtom } from "./store";
import PaymentConfirmation from "./PaymentConfirmation";

export default function EnquiryConfirmation() {
  const customerDetails = useAtomValue(customerDetailsAtom);

  return (
    <PaymentConfirmation
      heading={`Hello ${customerDetails?.name}, your booking enquiry has been sent`}
      body="Your enquiry has been received and is now being reviewed by our team. We'll contact you shortly to confirm availability and the next steps."
      summaryTitle="Enquiry Summary"
      showPayment={false}
    />
  );
}
